import { FC } from 'react'

import OktaLogo from '@/assets/logos/okta.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { SSO } from '@/out/single-sign-on'
import { SSOProps } from '@/pages/settings/single-sign-on'
import OktaDetails from '@/pages/settings/single-sign-on/okta/details'
import OktaForm from '@/pages/settings/single-sign-on/okta/form'

type Props = SSOProps<'okta'> & {
  configuration: SSO['okta']
  disabled?: boolean
}

const Okta: FC<Props> = ({ configuration, setupTimer, onSetup, removeTimer, onRemove, disabled = false }) => {
  return (
    <ServiceIntegrationCard
      title="Okta"
      description="Set up Okta to be the identity provider for single sign-on."
      icon={<OktaLogo className="w-8 h-8" />}
      iconColor="text-[#007dc1]"
      isConnected={!!configuration}
      disabled={disabled}
      disabledMessage="Disable the current provider to enable this one"
      setupContent={<OktaForm timer={setupTimer} onSetup={config => onSetup('okta', config)} />}
      manageContent={
        configuration ? (
          <OktaDetails configuration={configuration} timer={removeTimer} onRemove={() => onRemove('okta')} />
        ) : undefined
      }
    />
  )
}

export default Okta
